export default __webpack_public_path__ + "static/media/phone-01.b2eb48de.svg";